import React from 'react';

const RADIUS = 16;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS; // ~100.53

const getScoreColor = (score) => {
    if (score >= 80) return '#23b56e';
    if (score >= 60) return '#f59e0b';
    return '#ef4444';
};

const GlobalScoreHeader = ({ overallAccuracy, onApproveAll, allExpanded, onToggleAll, reviewStats }) => {
    const score = Number(overallAccuracy) || 0;
    const filledLength = (score / 100) * CIRCUMFERENCE;
    const emptyLength = CIRCUMFERENCE - filledLength;
    const scoreColor = getScoreColor(score);

    const stats = reviewStats || { total: 0, approved: 0, rejected: 0, pending: 0 };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'flex-end', gap: '1rem' }}>
            <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                    <span style={{
                        padding: '0.125rem 0.5rem', borderRadius: '0.25rem', fontSize: '10px', fontWeight: 'bold',
                        textTransform: 'uppercase', letterSpacing: '0.05em', backgroundColor: '#e0f2fe',
                        color: '#0284c7', border: '1px solid #bae6fd'
                    }}>
                        <i className="pi pi-sparkles" style={{ fontSize: '10px', marginRight: '0.25rem', verticalAlign: 'middle' }}></i>AI Powered
                    </span>
                    <span style={{
                        padding: '0.125rem 0.5rem', borderRadius: '0.25rem', fontSize: '10px', fontWeight: 'bold',
                        textTransform: 'uppercase', letterSpacing: '0.05em', backgroundColor: '#ffedd5', color: '#ea580c'
                    }}>
                        Revisión Supervisada
                    </span>
                </div>
                <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#0f172a', letterSpacing: '-0.025em', margin: 0 }}>
                    Validación Asistida por IA
                </h1>
                <p style={{ color: '#64748b', marginTop: '0.25rem', marginBottom: 0 }}>
                    Confirma las sugerencias de la IA para acelerar el proceso de aprobación.
                </p>
            </div>

            <div style={{ display: 'flex', gap: '0.75rem' }}>
                <div style={{
                    display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.5rem 1rem',
                    backgroundColor: '#ffffff', borderRadius: '0.5rem', border: '1px solid #e2e8f0',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', marginRight: '0.5rem'
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            Confianza Global
                        </span>
                        <span style={{ fontSize: '1.25rem', fontWeight: 'bold', color: scoreColor }}>
                            {score}%
                        </span>
                    </div>

                    {/* SVG Progress Ring */}
                    <div style={{ position: 'relative', width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg
                            width={40}
                            height={40}
                            viewBox="0 0 40 40"
                            style={{ transform: 'rotate(-90deg)' }}
                        >
                            {/* Background track */}
                            <circle
                                cx={20}
                                cy={20}
                                r={RADIUS}
                                fill="none"
                                stroke="#e2e8f0"
                                strokeWidth={4}
                            />
                            {/* Filled arc */}
                            <circle
                                cx={20}
                                cy={20}
                                r={RADIUS}
                                fill="none"
                                stroke={scoreColor}
                                strokeWidth={4}
                                strokeLinecap="round"
                                strokeDasharray={`${filledLength} ${emptyLength}`}
                                style={{ transition: 'stroke-dasharray 0.8s ease-in-out' }}
                            />
                        </svg>
                        <i
                            className="pi pi-bolt"
                            style={{
                                position: 'absolute',
                                color: '#0ea5e9',
                                fontSize: '0.875rem'
                            }}
                        />
                    </div>
                </div>

                <button
                    onClick={onToggleAll}
                    style={{
                        display: 'flex', alignItems: 'center', gap: '0.375rem', padding: '0.5rem 0.75rem',
                        backgroundColor: '#ffffff', color: '#475569', borderRadius: '0.5rem', fontSize: '0.8rem',
                        fontWeight: '500', transition: 'all 0.2s', border: '1px solid #e2e8f0', cursor: 'pointer',
                        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', whiteSpace: 'nowrap'
                    }}
                    onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f1f5f9'; e.currentTarget.style.borderColor = '#cbd5e1'; }}
                    onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#ffffff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                >
                    <i className={`pi ${allExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`} style={{ fontSize: '0.75rem' }}></i>
                    {allExpanded ? 'Plegar todo' : 'Desplegar todo'}
                </button>

                <button
                    onClick={onApproveAll}
                    style={{
                        display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem',
                        backgroundColor: '#0ea5e9', color: '#ffffff', borderRadius: '0.5rem', fontSize: '0.875rem',
                        fontWeight: '500', transition: 'background-color 0.2s', border: 'none', cursor: 'pointer',
                        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0284c7'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#0ea5e9'}
                >
                    <i className="pi pi-check-circle" style={{ fontSize: '16px' }}></i>
                    Aprobar Todo (Alto Score)
                </button>
            </div>
        </div>

            {/* Review stats counters */}
            {stats.total > 0 && (
                <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.375rem 0.75rem',
                        backgroundColor: '#dcfce7', borderRadius: '0.5rem', border: '1px solid #bbf7d0',
                    }}>
                        <i className="pi pi-check-circle" style={{ fontSize: '0.875rem', color: '#166534' }}></i>
                        <span style={{ fontSize: '0.8rem', fontWeight: '600', color: '#166534' }}>
                            Aprobados {stats.approved}/{stats.total}
                        </span>
                    </div>
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.375rem 0.75rem',
                        backgroundColor: '#fef2f2', borderRadius: '0.5rem', border: '1px solid #fecaca',
                    }}>
                        <i className="pi pi-times-circle" style={{ fontSize: '0.875rem', color: '#991b1b' }}></i>
                        <span style={{ fontSize: '0.8rem', fontWeight: '600', color: '#991b1b' }}>
                            Rechazados {stats.rejected}/{stats.total}
                        </span>
                    </div>
                    <div style={{
                        display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.375rem 0.75rem',
                        backgroundColor: '#f1f5f9', borderRadius: '0.5rem', border: '1px solid #e2e8f0',
                    }}>
                        <i className="pi pi-clock" style={{ fontSize: '0.875rem', color: '#64748b' }}></i>
                        <span style={{ fontSize: '0.8rem', fontWeight: '600', color: '#64748b' }}>
                            Pendientes {stats.pending}/{stats.total}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GlobalScoreHeader;
